module.exports = __webpack_public_path__ + "static/media/flag-check.f9971d85.svg";